class ProfileHead
    constructor: (el) ->
        @.$el = el
        @.$subscribeButton = @.$el.querySelector '.profile-head__subscribe'
        @.$titleEl = @.$el.querySelector '.profile-head__user'

        @.updateBreadcrumbs = @.$el.dataset?.ubc == "true"

        @.$el.classList.add 'profile-head--bound'
        @.InitEvents()
        if @.updateBreadcrumbs
            @.UpdateBreadcrumbs()
        return

    InitEvents: ->
        self = @
        if @.$subscribeButton
            @.$subscribeButton.addEventListener 'click', (e) ->
                e.preventDefault()
                @.classList.toggle 'profile-head__subscribed--active'
                @.querySelector '.button__text'
                    .textContent = if @.classList.contains('profile-head__subscribed--active') then @.dataset.subscribed else @.dataset.subscribe
                return
        return

    UpdateBreadcrumbs: ->
        if @.updateBreadcrumbs && @.$titleEl
            self = @
            document.querySelectorAll '.breadcrumbs--bound'
                .forEach (bcEl) ->
                    bcEl.dispatchEvent new CustomEvent 'breadcrumbs-add', {
                        bubbles: false,
                        detail: {
                            items: [
                                {
                                    link: window.location.href
                                    text: self.$titleEl.textContent
                                }
                            ]
                        }
                    }
                    return
        return

BindProfileHeads = ->
    document.querySelectorAll '.profile-head:not(.profile-head--bound)'
        .forEach (el) ->
            new ProfileHead el
            return
    return

window.addEventListener 'bind-components', BindProfileHeads